import * as React from 'react';

function Friend(props) {
    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 15.5C20 17.8256 18.6878 19.8141 16.8334 20.6185C18.176 20.979 19.391 21.7172 20.4052 22.6808C21.4189 21.6577 22.6518 20.8841 24.0212 20.5525C22.244 19.7092 21 17.7644 21 15.5C21 12.4624 23.2386 10 26 10C28.7614 10 31 12.4624 31 15.5C31 17.9019 29.6003 19.9442 27.6492 20.6938C28.9299 21.0949 29.998 21.8532 30.8418 22.845C32.1087 24.3342 32.859 26.3329 33.1202 28.4225C33.163 28.765 32.92 29.0774 32.5775 29.1202C32.235 29.163 31.9226 28.92 31.8798 28.5775C31.641 26.6671 30.9623 24.9158 29.8897 23.655C28.8292 22.4084 27.3735 21.625 25.4999 21.625C23.9322 21.625 22.4522 22.3743 21.2561 23.598C22.7186 25.3836 23.625 27.7087 23.625 30C23.625 30.3452 23.3452 30.625 23 30.625C22.6548 30.625 22.375 30.3452 22.375 30C22.375 27.9692 21.5416 25.8599 20.1808 24.2603C18.8209 22.6618 16.983 21.625 15 21.625C13.017 21.625 11.1791 22.6618 9.81919 24.2603C8.45838 25.8599 7.625 27.9692 7.625 30C7.625 30.3452 7.34518 30.625 7 30.625C6.65482 30.625 6.375 30.3452 6.375 30C6.375 27.645 7.33248 25.2543 8.8671 23.4504C10.0044 22.1135 11.4854 21.0699 13.1666 20.6185C11.3122 19.8141 10 17.8256 10 15.5C10 12.4624 12.2386 10 15 10C17.7614 10 20 12.4624 20 15.5ZM18.75 15.5C18.75 17.962 16.9616 19.75 15 19.75C13.0384 19.75 11.25 17.962 11.25 15.5C11.25 13.038 13.0384 11.25 15 11.25C16.9616 11.25 18.75 13.038 18.75 15.5ZM29.75 15.5C29.75 17.962 27.9616 19.75 26 19.75C24.0384 19.75 22.25 17.962 22.25 15.5C22.25 13.038 24.0384 11.25 26 11.25C27.9616 11.25 29.75 13.038 29.75 15.5Z"
            fill="#000"
            />
        </svg>
    );
}

export default Friend;
